export const Notice = {
    "已读":"Read",
    "已参与":"Participated",
    "未读":"Unread",
    "未参与":"Not participated",
    "提醒未读成员查看":"Urge",
    "系统提示":"System Prompt",
    "是否要给未读的学员进行提醒本提醒仅通过微信推送只有微信绑定的用户才能收到此提醒":"Do you want to remind unread students? This reminder can only be pushed through WeChat. Only users bound to WeChat can receive this reminder!",
    "提醒已经发送到学生的微信":"Reminder has been sent to students' WeChat",
    "评论内容不允许为空":"Comments cannot be empty!",
    "还没有评论，发表第一个评论吧":"There is no comment yet. Please make your first comment",
    "点击评论":"Click Comment",
    "友善是交流的起点":"Friendliness is the beginning of communication...",
    "删除评论成功":"Successfully deleted the comment!",
    "评论成功":"Comment successfully",
    "全部评论":"All comments",
    "发布你的评论":"Post your comments",
    "发布评论成功":"Successfully posted comments",
    "公告标题":"Announcement title",
    "导入已有公告":"Import existing announcements",
    "公告详情":"Announcement details",
    "选人":"pick",
    


}